import { styled } from '@mui/material/styles';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import {
  CbBorderBase,
  CbBorderRadiusBase,
  CbColorBackgroundBase,
  CbColorBackgroundHighlight,
  CbColorBackgroundSubtle,
  CbColorBorderActiveEmphasised,
  CbColorBorderBase,
  CbColorBorderHoverBase,
  CbColorIconInteractiveBase,
  CbFontSizeBase,
  CbFontWeightBold,
  CbLineHeightBody,
  CbShadowBase,
  CbTimeTransitionBase
} from '@coolblue-development/design-tokens';

// Mocking the current Coolblue style as we haven't fully integrated the design tokens yet neither installed the ds-mui-x package
// it should be removed after the migration to the React/Freddy/ds-mui-x package is complete.

export const StyledDataGrid = styled(DataGridPremium)(({ theme }) => ({
  lineHeight: CbLineHeightBody,
  fontSize: CbFontSizeBase,
  border: 0,
  '.MuiDataGrid-overlay, .MuiDataGrid-pinnedColumnHeaders, .MuiDataGrid-pinnedColumns': {
    backgroundColor: CbColorBackgroundBase
  },
  '.MuiDataGrid-columnSeparator': {
    visibility: 'hidden',
    color: CbColorIconInteractiveBase,
    '&:hover': { color: CbColorIconInteractiveBase }
  },
  '.MuiDataGrid-columnHeader': { padding: theme.spacing(0, 3, 0, 2) },
  '.MuiDataGrid-columnHeader:hover, .MuiDataGrid-columnHeader:focus-within': {
    '.MuiDataGrid-columnSeparator.MuiDataGrid-columnSeparator--resizable': { visibility: 'visible' }
  },
  '.MuiDataGrid-columnHeaderTitle': { fontWeight: CbFontWeightBold },
  '.MuiDataGrid-columnHeaders': { borderBottom: `${CbBorderBase} solid ${CbColorBorderBase}` },
  '.MuiDataGrid-cell': {
    padding: theme.spacing(0, 2),
    borderBottom: `${CbBorderBase} solid ${CbColorBorderBase}`
  },
  '.MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': { outline: 'none' },
  '.MuiDataGrid-cell:first-of-type:not(.MuiDataGrid-cellCheckbox), .MuiDataGrid-columnHeader:first-of-type:not(.MuiDataGrid-columnHeaderCheckbox)':
    {
      paddingLeft: theme.spacing(6)
    },
  '.MuiDataGrid-columnHeaderCheckbox, .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainerContent':
    {
      padding: 0,
      overflow: 'visible'
    },
  '.MuiDataGrid-footerContainer': {
    boxShadow: CbShadowBase,
    clipPath: 'inset(-8px 1px 1px 1px)',
    borderTop: 0,
    padding: theme.spacing(4, 0, 4, 6),
    minHeight: '4rem',
    position: 'relative',
    zIndex: 1
  },
  '.MuiDataGrid-row': {
    transitionProperty: 'background',
    transitionDuration: `${CbTimeTransitionBase}ms`,
    '&:hover, &.Mui-hovered': { backgroundColor: CbColorBackgroundSubtle },
    '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-hovered': {
      backgroundColor: CbColorBackgroundHighlight
    }
  },
  '.MuiDataGrid-editInputCell': { lineHeight: CbLineHeightBody, fontSize: CbFontSizeBase },
  '.MuiDataGrid-row--detailPanelExpanded': { backgroundColor: CbColorBackgroundHighlight },
  '.MuiDataGrid-detailPanel': {
    backgroundColor: CbColorBackgroundBase,
    borderBottom: `${CbBorderBase} solid ${CbColorBorderBase}`
  },
  '.MuiDataGrid-pinnedColumnHeaders, .MuiDataGrid-pinnedColumns': { boxShadow: CbShadowBase },
  '.MuiTablePagination-root': { width: '100%' },
  '.MuiToolbar-root': { width: '100%', paddingLeft: 0 },
  '.MuiTablePagination-spacer': { display: 'none' },
  '.MuiTablePagination-selectLabel': { fontSize: 'inherit', margin: 0 },
  '.MuiTablePagination-select': {
    height: '4rem',
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    border: `${CbBorderBase} solid ${CbColorBorderBase}`,
    borderRadius: CbBorderRadiusBase,
    padding: theme.spacing(3, '3.6rem', 3, 3),
    background: CbColorBackgroundBase,
    '&:hover': { border: `${CbBorderBase} solid ${CbColorBorderHoverBase}` }
  },
  '.Mui-focused > .MuiTablePagination-select': {
    border: `${CbBorderBase} solid ${CbColorBorderActiveEmphasised}`
  },
  '.MuiTablePagination-displayedRows': { fontSize: 'inherit', flexGrow: 1, textAlign: 'center' },
  '.MuiTablePagination-actions': { minWidth: '18rem', display: 'flex', justifyContent: 'end' }
}));
